import { Navigate, Outlet, useLocation } from "react-router-dom";
import cookiesModifier from "../utils/cookies";

const PrivateRoutes = () => {
    const location = useLocation();

    const tokenValidationRes = { result: cookiesModifier.getCookie('imm_consultant_token'), reason: 'not_found' };

    return (
        tokenValidationRes.result
            ? <Outlet />
            : <Navigate to='/login' state={{ from: location }} replace />
    );
};

export default PrivateRoutes;